import { useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { dashboardQueryKeys } from './dashboardQueryKeys'
import { useCurrentUserId } from './useCurrentUserId'

/**
 * Xoá cache dashboard của người dùng trước khi tài khoản đổi mà không qua đăng xuất
 * (ví dụ đăng nhập lại bằng modal khi token hết hạn). Đặt một lần ở lớp gốc của app.
 */
export const useResetDashboardCacheOnUserChange = (): void => {
  const queryClient = useQueryClient()
  const userId = useCurrentUserId()
  const previousUserId = React.useRef(userId)

  React.useEffect(() => {
    const previous = previousUserId.current
    if (previous !== userId) {
      if (previous) {
        queryClient.removeQueries({ queryKey: dashboardQueryKeys.user(previous) })
      }
      previousUserId.current = userId
    }
  }, [queryClient, userId])
}
